import { render, staticRenderFns } from "./RiskCatTemplate.vue?vue&type=template&id=4716a4cc&"
import script from "./RiskCatTemplate.vue?vue&type=script&lang=js&"
export * from "./RiskCatTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports